import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const BACKGROUND_MS = 30000;
let launched = false;

export function useScrollTopOnRoute() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
}

export function useFeedOnOpen() {
  const navigate = useNavigate();
  useEffect(() => {
    if (launched) return;
    launched = true;
    const params = new URLSearchParams(window.location.search);
    if (params.has("push")) {
      params.delete("push");
      const qs = params.toString();
      navigate(`${window.location.pathname}${qs ? `?${qs}` : ""}`, { replace: true });
      return;
    }
    if (isStandalone() && window.location.pathname !== "/feed") navigate("/feed", { replace: true });
  }, [navigate]);

  useEffect(() => {
    let hiddenAt = 0;
    const onVisible = () => {
      if (document.hidden) { hiddenAt = Date.now(); return; }
      const away = hiddenAt && Date.now() - hiddenAt > BACKGROUND_MS;
      hiddenAt = 0;
      if (away && isStandalone() && window.location.pathname !== "/feed") { navigate("/feed"); window.scrollTo(0, 0); }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [navigate]);
}
